import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/feature/Reveal';
import { openSupportChat } from '@/utils/supportChat';
import { SETUP_STEPS } from '@/pages/how-it-works/data';

const REQUIREMENTS = [
  { icon: 'ri-computer-line', text: 'MetaTrader 5 account with XAUUSD' },
  { icon: 'ri-wallet-3-line', text: '$500 minimum recommended' },
  { icon: 'ri-cloud-line', text: 'Windows VPS recommended' },
  { icon: 'ri-speed-line', text: 'Raw or low-spread account type' },
  { icon: 'ri-wifi-line', text: 'Stable internet connection' },
  { icon: 'ri-exchange-line', text: 'Hedging or netting — both supported' },
];

export default function SetupSteps() {
  return (
    <section id="setup" className="py-14 md:py-20 bg-background-100 scroll-mt-32 md:scroll-mt-36">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-shell mx-auto">
          <Reveal>
            <SectionHeading
              eyebrow="Setup"
              title="From download to live in about five minutes"
              subtitle="No coding, no configuration files to write, no dependencies. Follow these six steps once and you are done."
            />
          </Reveal>

          <div className="mt-10 md:mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {SETUP_STEPS.map((item, index) => (
              <Reveal key={item.id} delay={index * 60}>
                <div className="h-full rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
                  <span className="font-num text-2xl font-bold text-foreground-400">{item.step}</span>
                  <h3 className="mt-4 font-heading text-sm md:text-base font-semibold text-foreground-950">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-xs md:text-sm leading-relaxed text-foreground-600">{item.text}</p>
                  {item.id === 'risk' ? (
                    <Link
                      to="/get-ea#presets"
                      className="mt-3 inline-flex items-center gap-1.5 text-xs md:text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      See the risk preset table
                      <i className="ri-arrow-right-line" aria-hidden="true"></i>
                    </Link>
                  ) : null}
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={120}>
            <div className="mt-8 rounded-lg bg-primary-950 p-6 md:p-8">
              <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
                <div>
                  <h3 className="font-heading text-lg md:text-xl font-semibold text-background-50">
                    What you need before you start
                  </h3>
                  <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-3">
                    {REQUIREMENTS.map((req) => (
                      <span key={req.text} className="flex items-center gap-2.5 text-xs md:text-sm text-background-200/90">
                        <i className={`${req.icon} text-accent-400`} aria-hidden="true"></i>
                        {req.text}
                      </span>
                    ))}
                  </div>
                </div>
                <div className="shrink-0 w-full lg:w-auto flex flex-col sm:flex-row lg:flex-col gap-3">
                  <button
                    type="button"
                    onClick={openSupportChat}
                    className="inline-flex items-center justify-center gap-2 rounded-full bg-accent-500 hover:bg-accent-400 px-6 py-3.5 text-sm font-semibold text-primary-950 transition-all duration-200 hover:-translate-y-0.5 whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-customer-service-2-line text-lg" aria-hidden="true"></i>
                    Get the EA free
                  </button>
                  <Link
                    to="/performance"
                    className="inline-flex items-center justify-center gap-2 rounded-full border border-background-50/25 px-6 py-3.5 text-sm font-semibold text-background-50 hover:bg-background-50/10 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-line-chart-line text-lg" aria-hidden="true"></i>
                    See live performance
                  </Link>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}